import {
  SHOW_ACCOUNT_MODAL,
  CLOSE_ACCOUNT_MODAL,
  SHOW_RESEND_EMAIL_MODAL,
  CLOSE_RESEND_EMAIL_MODAL,
  UPDATE_ACTIVE_BUILDING,
  UPDATE_COMMUNICATION_PREFERENCES
} from '../actions/account.js'

const accountReducer = (state = { showAccountModal: false }, action) => {
  switch (action.type) {
    case SHOW_ACCOUNT_MODAL:
      return {
        ...state,
        showAccountModal: true
      }
    case CLOSE_ACCOUNT_MODAL:
      return {
        ...state,
        showAccountModal: false
      }
    case SHOW_RESEND_EMAIL_MODAL:
      return {
        ...state,
        showResendEmailModal: true,
        showAccountModal: false
      }
    case CLOSE_RESEND_EMAIL_MODAL:
      return {
        ...state,
        showResendEmailModal: false,
        showAccountModal: true
      }

    case UPDATE_ACTIVE_BUILDING:
      return {
        ...state,
        account: { ...state.account, activeBuilding: action.activeBuilding }
      }

    case UPDATE_COMMUNICATION_PREFERENCES:
      return {
        ...state,
        account: { ...state.account, communicationPreferences: action.communicationPreferences }
      }

    default:
      return state
  }
}

export default accountReducer



// WEBPACK FOOTER //
// ./src/reducers/account.js